import { createContext, useEffect, useState } from "react";

import {
  useLocation
} from "react-router-dom";

import en from '../components/LanguageFolder/en.json'
import tr from '../components/LanguageFolder/tr.json'
import de from '../components/LanguageFolder/de.json'



const LanguageContext = createContext();

export  const  Language = ({children}) =>{
  const location = useLocation();
  const [lang , setlang] = useState(location.pathname.split("/").pop()  === "tr" ? "tr" :  location.pathname.split("/").pop() === "de" ? "de" : "en" )


  if((location.pathname.split('/').pop() !== "tr" && location.pathname.split('/').pop() !== "de" && location.pathname.split('/').pop() !== "en") )
  {
       sessionStorage.setItem("lang","en")
  }
  else{
     sessionStorage.setItem("lang",lang)

  }

 

    useEffect(() => {
      if((location.pathname.split('/').pop() !== "tr" && location.pathname.split('/').pop() !== "de" && location.pathname.split('/').pop() !== "en" ) )
      {
           sessionStorage.setItem("lang","en")
      }
      else{
        sessionStorage.setItem("lang",lang)
      }
    })


    if(location.pathname.split('/').pop() === "tr"){
           sessionStorage.setItem("lang","tr")
     }
     else if(location.pathname.split('/').pop() === "en"){
          sessionStorage.setItem("lang","en")
     }
      else if(location.pathname.split('/').pop() === "de"){
         sessionStorage.setItem("lang","de")
     }

       else{
        sessionStorage.setItem("lang","en")
      }



    const value = {
      lang,
      setlang,
      en,
      tr,
      de
    };


  return  <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}




export default  LanguageContext;